import React from "react";

const SvgBBiconsBmStredniHodnoty = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <style>
      {".BBicons_BM-Stredni_hodnoty_svg__st4{display:none;fill:#6afff8}"}
    </style>
    <g id="BBicons_BM-Stredni_hodnoty_svg__Bo\u010Dn\xED_menu">
      <circle
        className="BBicons_BM-Stredni_hodnoty_svg__st4"
        cx={97.2}
        cy={100}
        r={126.4}
      />
      <circle
        className="BBicons_BM-Stredni_hodnoty_svg__st4"
        cx={-120}
        cy={100}
        r={126.4}
      />
      <circle
        className="BBicons_BM-Stredni_hodnoty_svg__st4"
        cx={100}
        cy={100}
        r={126.4}
      />
      <path
        d="M30.7 43.3c-3.5 0-6.4 2.8-6.4 6.3v93.2c0 3.5 2.9 6.3 6.4 6.3h77.7c0-.1 0-.2.1-.3.1-.3.1-.5.2-.8l6.4-11.5v-8.6c-.8.1-1.5.2-2.3.2-1.5 0-3-.2-4.4-.4v14.7H73.1V125h28.4c-1.9-1.1-3.7-2.3-5.2-3.9-.9-.9-1.6-1.9-2.4-2.9H73.1V101h16.8c.3-1.9.8-3.7 1.5-5.4.2-.5.5-.9.7-1.3h-19V77h35.3v4.8c1.4-.3 2.9-.4 4.4-.4.8 0 1.5.2 2.3.2V77h35.3v1.1c1-.4 2.1-.7 3.3-.7 1.2 0 2.4.3 3.4.7V49.6c0-3.5-2.9-6.3-6.3-6.3H30.7zm.4 6.7h119.3v20.3H31.1V50zm0 27h35.3v17.3H31.1V77zm0 24h35.3v17.3H31.1V101zm0 24h35.3v17.3H31.1V125zM158 87.3c0 .8-.2 1.4-.6 2.1l-37.1 65.2h-.1c-.6 1.3-1.9 2.2-3.4 2.2-2.2 0-3.9-1.8-3.9-4 0-.7.2-1.4.6-2h-.1l36.4-65.5h.1c.7-1.3 2.1-2.2 3.7-2.2 2.4-.1 4.4 1.8 4.4 4.2zm-45.2-.4c-2.5 0-4.8.5-6.9 1.4-2.2.9-4 2.2-5.6 3.8-1.6 1.6-2.8 3.5-3.8 5.7-.9 2.2-1.4 4.5-1.4 6.9 0 2.5.5 4.8 1.4 6.9.9 2.2 2.2 4 3.8 5.7 1.6 1.6 3.5 2.9 5.6 3.8 2.2.9 4.5 1.4 6.9 1.4 2.5 0 4.8-.5 6.9-1.4 2.2-.9 4-2.2 5.6-3.8 1.6-1.6 2.8-3.5 3.8-5.7.9-2.2 1.4-4.5 1.4-6.9 0-2.5-.5-4.8-1.4-6.9-.9-2.2-2.2-4.1-3.8-5.7-1.6-1.6-3.5-2.9-5.6-3.8-2.2-.9-4.5-1.4-6.9-1.4zm0 9.2c2.4 0 4.4.8 6.1 2.5 1.6 1.7 2.5 3.7 2.5 6.1 0 2.4-.8 4.4-2.5 6.1-1.6 1.7-3.7 2.5-6.1 2.5-2.4 0-4.4-.8-6.1-2.5-1.7-1.7-2.5-3.7-2.5-6.1s.8-4.4 2.5-6.1c1.7-1.6 3.7-2.5 6.1-2.5zm45.2 21c-2.5 0-4.8.5-6.9 1.4-2.2.9-4 2.2-5.6 3.8-1.6 1.6-2.8 3.5-3.8 5.7-.9 2.2-1.4 4.5-1.4 6.9 0 2.5.5 4.8 1.4 7 .9 2.2 2.2 4.1 3.8 5.7 1.6 1.6 3.5 2.9 5.6 3.8 2.2.9 4.4 1.4 6.9 1.4s4.8-.5 6.9-1.4c2.2-.9 4-2.2 5.6-3.8 1.6-1.6 2.8-3.5 3.8-5.7.9-2.2 1.4-4.5 1.4-7s-.5-4.8-1.4-6.9c-.9-2.2-2.2-4.1-3.8-5.7-1.6-1.6-3.5-2.9-5.6-3.8-2.2-1-4.5-1.4-6.9-1.4zm0 9.1c2.4 0 4.4.8 6.1 2.5 1.6 1.7 2.5 3.7 2.5 6.1 0 2.5-.8 4.5-2.5 6.2-1.7 1.7-3.7 2.5-6.1 2.5-2.4 0-4.4-.8-6.1-2.5-1.6-1.7-2.5-3.7-2.5-6.2 0-2.4.8-4.4 2.5-6.1 1.7-1.6 3.7-2.5 6.1-2.5z"
        id="BBicons_BM-Stredni_hodnoty_svg__Stredni_hodnoty"
      />
      <circle
        className="BBicons_BM-Stredni_hodnoty_svg__st4"
        cx={320}
        cy={100}
        r={126.4}
      />
    </g>
  </svg>
);

export default SvgBBiconsBmStredniHodnoty;
